import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

/**
 * There is no applications LIST surface — only the per-application approval
 * child route. Without this redirect the bare URL renders a permanently
 * empty outlet (Ember auto-generates the parent index), so send visitors to
 * the functional sibling: the approval queue.
 */
export default class AuthenticatedAdminTasApplicationsIndexRoute extends Route {
  @service declare router: RouterService;

  redirect() {
    this.router.replaceWith('authenticated.admin.tas.approval-queue');
  }
}
